<template>
<div class="row">
  <div class="col-sm-12">

    <div class="row" style='margin-top:25px'>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="control-label">Titre * </label>
          <input v-model="service.name" type="text" class="form-control" >
          <label class="error" v-if="errors.name">{{ errors.name }}</label>
        </div>
      </div>
    </div>
    <div class="row" style='margin-top:25px;margin-bottom:25px'>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="control-label">Description </label>
          <trumbowyg v-model="service.description" :config="config" class="form-control" name="content"></trumbowyg>
          <label class="error" v-if="errors.description">{{ errors.description }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button class="btn btn-primary" v-on:click="save">Enregistrer</button>&nbsp;
        <button class="btn btn-default" v-on:click="back" >Retour</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

import {en, fr} from 'vuejs-datepicker/dist/locale';

export default {
  data: function() {return {
    service_id:0,
    serviceprovider:{},
    service:{},
    errors:{name:'',description:''},
    messages:{},
    fr:fr,
    en:en,
    config: this.$trumbowygConfig,

  }},
  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_service.php',
          { params: {service_id:this.$route.params.service_id,service_provider_id: this.$route.params.service_provider_id}})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.serviceprovider = response.data.serviceprovider;
          this.service = response.data.service}
        )
    },
    back: function()
    {
      this.$router.go(-1);
    },

    save: function()
    {
      var empty_field = false;

      if(this.service.name == '')
      {
        this.errors.name = this.messages.required;
        empty_field = true;
      }
      else
        this.errors.name = '';

      
      if(!empty_field)
      {
        let data = {
          service_id: this.service_id,
          name: this.service.name,
          description: this.service.description,
          service_provider_id:this.$route.params.service_provider_id

        }
        axios
          .post(this.$root.$data.server_base + '/api/service_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})

          .then(() => (
              this.$router.push({name:'services', params: {
              service_provider_id: this.$route.params.service_provider_id,
              }})))

      }
    },

  },
  mounted () {
    if(this.$route.params.service_id)
      this.service_id=this.$route.params.service_id;
    this.refresh();
    this.messages = this.$root.$data.messages;

  }
}
</script>
